import { BaseConfig } from '../ServiceConfig';

export interface LoyaltyConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.LoyaltyServiceConfigData';
  url: string;
  bffUrl: string;
  clientId: string;
  iamAudience: string;
  linkMembershipUrl: string;
  registerMemberUrl: string;
  allowLinkMembership: boolean;
  allowRegisterMembership: boolean;
  membershipCodeFormat: string;
  networkName: string;
  merchantCode: string;
}

export const LoyaltyConfigurationFields: (keyof LoyaltyConfiguration)[] = [
  'url',
  'bffUrl',
  'iamAudience',
  'clientId',
  'linkMembershipUrl',
  'registerMemberUrl',
  'allowLinkMembership',
  'allowRegisterMembership',
  'membershipCodeFormat',
  'networkName',
  'merchantCode',
];

export const BlankLoyaltyConfiguration: LoyaltyConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.LoyaltyServiceConfigData',
} as LoyaltyConfiguration;
